import React, { useState } from "react";
import { submitSuggestedSourceUrl } from "../../api/sourceSubmissions";

export default function SuggestSourceUrlModal({ onClose, onAskParentsWhatsApp }) {
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);
    setBusy(true);
    try {
      await submitSuggestedSourceUrl(url.trim());
      setSuccess(true);
      setUrl("");
    } catch (err) {
      setError(err?.message || "Speichern fehlgeschlagen.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="plan-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-busy={busy}
      aria-label="Aktivität teilen"
    >
      <div className="plan-modal" onClick={(e) => e.stopPropagation()}>
        <div className="plan-modal-header">
          <h3>Aktivität teilen</h3>
          <button
            type="button"
            className="plan-modal-close"
            onClick={onClose}
            aria-label="Schliessen"
          >
            ×
          </button>
        </div>
        <form className="add-card-form" onSubmit={handleSubmit}>
          <div className="add-card-form-content">
            <p className="add-card-meta-hint">
              Hier kannst du eine Idee oder eine Webseite ablegen — für dich, damit du sie
              später wiederfindest, oder als Tipp für andere Eltern. Ein https‑Link reicht.
              Wir prüfen den Vorschlag und übernehmen passende Quellen nach und nach in
              Albis.
            </p>
            <label className="add-card-label">
              https‑Link (Aktivität oder Seite)
              <input
                type="url"
                required
                className="add-card-input"
                placeholder="https://…"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                disabled={busy}
                autoComplete="url"
              />
            </label>
            {success && (
              <p className="add-card-meta-hint" role="status">
                Danke — wir haben das gespeichert und schauen uns den Tipp an.
              </p>
            )}
            {error ? <p className="add-card-error">{error}</p> : null}
          </div>
          {onAskParentsWhatsApp ? (
            <div className="add-card-actions add-card-actions-wrap">
              <div className="add-card-actions-row">
                <button
                  type="button"
                  className="add-card-btn add-card-btn-secondary"
                  onClick={onClose}
                  disabled={busy}
                >
                  Schliessen
                </button>
                <button
                  type="submit"
                  className="add-card-btn add-card-btn-primary"
                  disabled={busy || !url.trim()}
                >
                  {busy ? "Senden…" : "Absenden"}
                </button>
              </div>
              <button
                type="button"
                className="add-card-btn add-card-btn-invite-whatsapp"
                onClick={onAskParentsWhatsApp}
                aria-label="WhatsApp öffnen, um Aktivitätstipps von Freunden einzuholen"
              >
                Aktivitäten von Freunden (WhatsApp)
              </button>
            </div>
          ) : (
            <div className="add-card-actions">
              <button
                type="button"
                className="add-card-btn add-card-btn-secondary"
                onClick={onClose}
                disabled={busy}
              >
                Schliessen
              </button>
              <button
                type="submit"
                className="add-card-btn add-card-btn-primary"
                disabled={busy || !url.trim()}
              >
                {busy ? "Senden…" : "Absenden"}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
